import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect, useMemo } from "react";
import images from './images'
import { Link } from "react-router"

import { database } from "./firebaseConfig2";
import Status from './components/status'
import Josh from "./components/josh"
import joshwhistle from "./other-assets/joshed.mp3";
import Photocards from "./components/photocards"
import Adoptable from "./components/adoptable"
// import Blog from './components/blog';
import Blorbo from './components/blorbo';
import Chatbox from './components/chatbox';

import fanlistings from './components/object-lists/fanlistings';
import stamps from './components/object-lists/stamps';
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import Hatchery from './components/hatchery';
import Webring1 from './components/webring1';
import Library from './components/library';
import { useNavigate } from "react-router";
import SpotifyPlayer from './components/spotifyPlayer';
import StatusCurrently from './components/statusCurrently';
import SiteUpdates from './components/site-updates';
import Fanlistings from './components/fanlistings';
import OcArt from './components/ocArt';


function Home() {
  // console.log("In HOME");
    const [josh, setJosh] = useState(false);

    const [main, setMain] = useState(true);
    const [about, setAbout] = useState(false);
    const [hatchery, setHatchery] = useState(false);
    const [blog, setBlog] = useState(false);
    const [library, setLibrary] = useState(false);

    const [codeCopied, setCodeCopied] = useState(false);

    const listStamps =  useMemo(() => shuffle(stamps.map(temp =><img key={temp.url} src={temp.url}/>)), []);

    let navigate = useNavigate();

    function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
        }
      return array;
    }

    function copy_btn_to_clipboard(){
      var text = '<a href="https://marketchipping.xyz" title="marketchipping.xyz"><img src="http://marketchipping.xyz/images/marketchipping.gif" width="88" height="31"/></a>'
      navigator.clipboard.writeText(text);
      setCodeCopied(true);
      // console.log(codeCopied);
      const timer = setTimeout(() => {
        setCodeCopied(false);
        // console.log(codeCopied);

      }, 1500);
      

    }

  let whistle = new Audio(joshwhistle);

  const handleJosh = () =>{
    setJosh(true);
    whistle.play();
    
    setTimeout(function() { setJosh(false); }, 3500);
    setTimeout(function() { whistle.pause(); }, 3560);

  }

  const handlePages = (pageName) =>{
    setMain(false);
    setAbout(false);
    setHatchery(false);
    setBlog(false);
    setLibrary(false);

    if (pageName == "about"){
      setAbout(true);
    }
    if (pageName == "main"){
      setMain(true);
    }
    if (pageName == "blog"){
      setBlog(true);
    }
    if (pageName == "hatchery"){
      setHatchery(true);
    }
    if (pageName == "library"){
      setLibrary(true);
    }
  }



  return (
      <div className='site-container'>
          <div className={'page-controller'}>
          <div className= {main ? "main-page-top-wrapper" :  "page-hidden"}>
            
            <div className='left-column'>
          {/* <!-- TITLE --> */}
          <div className = "title">
              <h1>⋅─ marketchipping ─⋅</h1>
          </div>

            {/* PFP */}
            <div className = "headshot">
              <div className = "icon">
                  <img id = "binari" src = {images.binari.url}></img>
                  {/* <img id = "frame" src = {frame}></img> */}
              </div>
              <div className = "attr">
                  <a href="https://www.webtoons.com/en/fantasy/the-dark-lords-confession/list?title_no=4464">icon: the dark lord's confession</a>   
              </div>
            </div>

          {/* <!-- LINKS --> */}
          <div className = "links">
            <div className= {josh ?'popupWrapperActive':'popupWrapperHidden'} >
            <Josh josh={josh}/>
          </div>
              <p>⊹ links ⊹</p>
              <div className = "linkswrapper">
                  <div onClick={() => navigate('/about')}> ✮ info </div>

                  <div onClick={() => window.location.href='https://marketchipping.atabook.org/'}>✮ guestbook</div>
                  <div  onClick={() => handleJosh()}>✮ josh</div>
                  {/* <div onClick={() => navigate('/library')}> ✮ library </div> */}
              </div>
          </div>
          <div id="welcome-container" className="status-wrapper">
              <div className="status-title"><p>⊹ welcome</p></div>
              <div className='status-details'>
                    <div className = "status-message" id="about-me-description">
                    <p>welcome to my personal site!</p>
                    <p>this website adheres to industry standard mobile-second web design. feel free to view on your phone for a mobile-second browsing experience.</p>
                    <p>it's still under construction (but aren't they all?)</p>
                  </div>
              </div>
             
            </div>


          
              
          {/* <div className='pagedolls'>
            <img className="pagedolls-img" src={images.bao2.url} alt="baobear"></img>
            <img className="pagedolls-img" src={images.bao.url} alt="baobear"></img>
            </div> */}
          </div>

          <div className="mainmenu">

            {/* DISPLAY VIRTUAL PETS  */}
          <Adoptable handlePages={handlePages}/>

          {/* STATUS WINDOW */}
            <Status/>

            {/* CURRENTLY...  */}
                <StatusCurrently/>
            

          </div>

        

          {/* <!-- OTHERS --> */}
          <div className = "other">
            <div id = "other-positioner">
              {/* PHOTO CARDS */}
             <div id = "photocards-positioner">
                <div className='status-title' id="photocards-title"><p>☽ .* :☆ﾟ. ────── photocards</p></div>
                <Photocards shuffle={shuffle}/>
              </div>


              <div className='site-stats'>
              {/* UPDATES */}
                <SiteUpdates/>
                <div className="status-wrapper">

              {/* BUTTON */}
            <div className="status-title"><p>⊹ site button</p></div>

                <div id="button-status" className = "status">
                <div className = "status-details" id="button-container">
                     <div onClick={()=> copy_btn_to_clipboard()} id = "site-button">
                        <img src={images.button.url} width="88" height="31"/>
                    </div>
                    </div>
                    <div className='button-tooltip'>
                      {(codeCopied) == true ?
                    <>
                      <p>Copied!</p>
                    </>
                     : <>
                      <p>Click button to copy embed code!</p>
                    </>
                    }
                    </div>
                    
                </div>
            </div>
              </div>


            {/* OC Display */}
            <OcArt/>
  
            </div>

             
              
              
          </div>
          </div>
          {/* <Blog blog={blog} handlePages={handlePages}/> */}

    {/* PAGE 2 */}
    <div id="page2" className= {main ? "main-page-top-wrapper" :  "page-hidden"}>


            <div className='left-column' id="left-column-2">
              {/* BLORBO */}
              <Blorbo/>

              {/* CHATBOX */}
              <Chatbox/>
            </div>



          <div className="mainmenu" id="mainmenu-2">
            <div className='status-wrapper' id="stamps-wrapper">
              <div className='status-title'><p>⊹ stamps</p></div>
              <div className = "badges">
                {/* <!-- BADGES / DOODADS --> */}
                {listStamps}
              </div>
            </div>

             {/* IDK WHAT TO PUT HERE */}
              <div className='status-wrapper' id="deco-wrapper">
                   <img id="mozarella" src={images.velvetmoth_mozarella.url}></img>
              </div>

            {/* The "GOD FUCKING DAMN IT KRIS" webring */}
            <div className='status-wrapper' id="webring-wrapper">
              <div className='status-title'><p>⊹ webrings</p></div>
              <div className = "status-details">
                  <Webring1/>
                </div>
            </div>
            

          </div>
          
          {/* <!-- OTHERS --> */}
          <div id = "other-2" className = "other">
            <div id = "other-positioner">

              {/* <img id="strawberrygif1" src={images.strawberrygif.url}></img> */}

              
              {/* FANLISTINGS */}
              <Fanlistings shuffle={shuffle}/>

              {/* SONG OF THE WEEK */}
              <SpotifyPlayer/>


              {/* <img id="strawberrygif2" src={images.strawberrygif.url}></img> */}
          </div>
          <img className="deco"  id="inkcap-deco" src={images.mudflower_inkcap.url}></img>
          </div>

        

          
    </div>
</div>
</div>


  );
}

export default Home;
